/**
 *  @class
 *  @function SaleTimer
 */
if (!customElements.get('sale-timer')) {
	class SaleTimer extends HTMLElement {
		constructor() {
			super();

			const date = this.dataset.date.split('-'),
				day = parseInt(date[0]),
				month = parseInt(date[1]),
				year = parseInt(date[2]);

			let time = this.dataset.time,
				tarhour, tarmin;

			if (time != null) {
				time = time.split(':');
				tarhour = parseInt(time[0]);
				tarmin = parseInt(time[1]);
			}

			// Set the date we're counting down to
			this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();
		}
		connectedCallback() {
			let _this = this;

			let dateHolder = _this.querySelector('[data-remaining-time]');
			const updateTime = function () {

				// Get todays date and time
				const now = new Date().getTime();
				// Find the distance between now an the count down date
				const distance = _this.countDownDate - now;
				// Time calculations for days, hours, minutes and seconds
				const days = Math.floor(distance / (1000 * 60 * 60 * 24));
				const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((distance % (1000 * 60)) / 1000);

				//At SG's request, only show the sale timer when less than a week is left
				if (!isNaN(days) && days < 7) {
					_this.removeAttribute("hidden");
				}
				if (days >= 2) {
					setTimeout(() => {
						requestAnimationFrame(updateTime);
					}, 1000);
					dateHolder.innerHTML = `${days} days`;
				} else if (days == 1) {
					setTimeout(() => {
						requestAnimationFrame(updateTime);
					}, 1000);
					dateHolder.innerHTML = `${hours + 24} hours and ${minutes} minutes`;
				} else if ((hours >= 12)) {
					setTimeout(() => {
						requestAnimationFrame(updateTime);
					}, 1000);
					dateHolder.innerHTML = `${hours} hours and ${minutes} minutes`;
				} else if ((days == 0) && (hours < 12)) {
					setTimeout(() => {
						requestAnimationFrame(updateTime);
					}, 1000);
					dateHolder.innerHTML = `${hours} hours ${minutes} minutes and ${seconds} seconds`;
				}

			};
			requestAnimationFrame(updateTime);
		}
		static addZero(x) {
			return (x < 10 && x >= 0) ? "0" + x : x;
		}
	}
	customElements.define('sale-timer', SaleTimer);
}
